import { memo } from 'react';

// Components
import Textbox from '../../../../components/Textbox';

// Utils
import {
  sanitizeAcctNumInput,
  onBlurValidateGoogleAdsID,
} from '../../../../utils';

interface AccountInputsProps {
  index: number;
  valueName: string;
  valueNumber: string;
  isRemoveable: boolean;
  onRemove: (index: number) => void;
  onChangeName: (val: string, index: number) => void;
  onChangeNumber: (val: string, index: number) => void;
}

function AccountInputs({
  index,
  valueName,
  valueNumber,
  isRemoveable,
  onRemove,
  onChangeName,
  onChangeNumber,
}: AccountInputsProps) {
  return (
    <div className="grid grid-cols-2 gap-4 relative">
      <div>
        <Textbox
          tooltip="onboarding.google_ads_account_name"
          label="Account Name"
          placeholder="Account Name"
          onChange={(val) => {
            onChangeName(val, index);
          }}
          value={valueName}
          required
        />
      </div>
      <div>
        <Textbox
          tooltip="onboarding.google_ads_account_number"
          label="Account Number"
          placeholder="XXX-XXX-XXXX"
          value={valueNumber}
          onChange={(val, evt) => {
            const sanitizedVal = sanitizeAcctNumInput(val, evt, valueNumber);
            onChangeNumber(sanitizedVal, index);
          }}
          pattern="^[0-9\-?]*$"
          onBlur={(evt) => {
            onBlurValidateGoogleAdsID(evt);
          }}
          required
        />
      </div>
      {isRemoveable ? (
        <i
          id="x-icon"
          className="absolute top-0 right-0"
          onClick={() => {
            onRemove(index);
          }}
        />
      ) : null}
    </div>
  );
}

export default memo(AccountInputs);
